export const AMPLITUDE_EVENTS = {
  LOGIN_SCREEN_SEEN: 'Login Screen Seen',
  LOGIN_SCREEN_CONTINUE_TAPPED: 'Continue Tapped On Login Screen',
  CODE_ENTRY_SCREEN_SEEN: 'Email Code Entry Screen Seen',
  CODE_ENTRY_SCREEN_SEEN_LOGGED_IN: 'Email Code Entry Screen Seen When Logged In',
  CODE_RESEND_TAPPED: 'Resend Email Code Tapped',
  ACCOUNT_CREATION_SCREEN_SEEN: 'Create Account Screen Seen',
  ACCOUNT_CREATED: 'Account Created',
  ACCOUNT_VERIFY_MODAL_SEEN: 'Account Verify Modal Seen',
  ACCOUNT_VERIFY_MODAL_GET_CODE_CLICKED: 'Get Code Clicked On Verify Email Modal',
  COUNTRY_CODE: 'Country Code',
  EMAIL_VERIFICATION_MODAL_SEEN: 'Verify Your Account Modal Seen',
  EMAIL_VERIFIED_LOGGED_IN: 'Email Verified When Logged In',
  YEAR_OF_BIRTH: 'Year Of Birth',
  PROFILE_IMAGE_ADDED: 'Profile Image Added',
  EMAIL_CODE_ENTERED: 'Email Code Entered',
  EMAIL_CODE_ENTERED_LOGGED_IN: 'Email Code Entered When Logged In',
  EMAIL_CODE_PASTED: 'Email Code Pasted',
  EMAIL_CHANGE_TAPPED: 'Change Email Button Tapped',
  CORRECT_CODE_ENTERED: 'Correct Code Entered',
  FEDERATION_TAPPED: 'Federation Tapped',
  FEDERATION_SELECTED: 'Federation Selected',
  FEDERATION_NAME: 'Federation Name',
  FEDERATION_ID_SCREEN_SEEN: 'Add Federation-ID screen seen',
  FEDERATION_ID_ADDED: 'Federation ID Added',
  FEDERATION_ID: 'Federation ID',
  SIGN_IN_TAPPED: 'Sign In Tapped',
  OPERATIONAL_STATUS_TAPPED: 'Operational Status Tapped',
  TEE_SHEET_COURSES_SEEN: 'Tee Sheet Courses Seen',
  TEE_TIME_TAPPED: 'Tee Time Tapped',
  TEE_TIME_DOUBLE_TAPPED: 'Tee Time Double Tapped',
  COURSE_BOOKING_SCREEN_SEEN: 'Course Booking Screen Seen',
  TEE_TIME_SLOT_SELECTED: 'Tee Time Slot Selected',
  TEE_SLOTS_ADDED: 'Tee Slots Added',
  CONFIRM_BOOKING_TAPPED: 'Confirm Booking Tapped',
  PLAYERS_ADDED: 'Players Added',
  ABORT_BOOKING_TAPPED: 'Abort Booking Tapped',
  COURSES_TEE_SHEET_SEARCHED: 'Courses Tee Sheet Searched',
  SIMULATORS_TEE_SHEET_SEARCHED: 'Simulators Tee Sheet Searched',
  RANGES_TEE_SHEET_SEARCHED: 'Driving Ranges Tee Sheet Searched',
  PRO_TEE_SHEET_SEARCHED: 'Pro Tee Sheet Searched',
  OTHERS_TEE_SHEET_SEARCHED: 'Others Tee Sheet Searched',
  TODAY_BUTTON_TAPPED: 'Today Button Tapped',
  COPY_LINK_TO_TEE_SHEET_TAPPED: 'Copy Link To Tee Sheet Tapped',
  EDIT_TEE_TIMES_TAPPED: 'Edit Tee Times Tapped',
  CANCEL_BOOKING_TAPPED: 'Cancel Booking Tapped',
  REFUND_AND_CANCEL_BOOKING_TAPPED: 'Refund And Cancel Booking Tapped',
  MARKED_AS_PAID_BOOKING_TAPPED: 'Marked As Paid Booking Tapped',
  CALENDARS_TAPPED: 'Calendars Tapped',
  RENTALS_TAPPED: 'Rentals Tapped',
  PAYMENTS_TAPPED: 'Payments Tapped',
  BOOKINGS_TAPPED: 'Bookings Tapped',
  NO_SHOW_TAPPED: 'No Show Tapped',
  PLAYERS_TAPPED: 'Players Tapped',
  MEMBERSHIPS_TAPPED: 'Memberships Tapped',
  PASSES_TAPPED: 'Passes Tapped',
  STATISTICS_TAPPED: 'Statistics Tapped',
  INSIGHTS_TAPPED: 'Insights Tapped',
  REPORTS_TAPPED: 'Reports Tapped',
  COMMUNICATION_TAPPED: 'Communication Tapped',
  VOUCHERS_TAPPED: 'Vouchers Tapped',
  PARTNERSHIPS_TAPPED: 'Partnerships Tapped',
  PROCEED_TO_CHECKOUT_TAPPED: 'Proceed To Checkout Tapped',
  PLAYER_ROLE: 'Player Role',
  CUSTOMER: 'Customer',
  GOLF_GENIUS_DEEP_LINK_TAPPED: 'Golf Genius Deep Link Tapped',
  PAYMENT_LINKS: {
    COPY_TAPPED: 'Copy Payment Link Tapped',
    NOTE_SAVED: 'Payment Link Note Saved',
    GO_TO_BOOKING_TAPPED: 'Go to Booking From Payment Link Tapped',
    SEARCHED: 'Payment Links Searched',
    BUTTON_IN_BOOKING_WINDOW_TAPPED: 'Payment Link In Booking Window Tapped',
    DELIVERY_METHOD: 'Delivery Method',
    RECIEVER_EDITED: 'Receiver Edited',
    SENT: 'Payment Link Sent',
    DEFAULT_SETTINGS_OVERRIDEN: 'Default Settings Overriden',
    NOTE_ADDED: 'Note Added',
    AUTOMATIC_LINKS_ACTIVATED: 'Automatic Payment Links Activated',
    PARTNER_NAME: 'Partner Name',
  },
}

export const AMPLITUDE_USER_PROPERTIES = {
  USER_ROLE: 'user_role',
  VENUE_TYPE: 'venue_type',
  SCREEN_SIZE: 'screen_size',
  CUSOTMER: 'customer',
  FEDERATION: 'federation',
  RELEASE_VERSION: 'release_version',
  ACTIVE_MEMBERSHIPS: 'active_memberships',
  ACTIVE_PASSES: 'active_passes',
  EMAIL_VERIFIED: 'email_verified',
}

export const AMPLITUDE_OPERATION_METHODS = {
  SET: 'set',
  POST_INSERT: 'post_insert',
}
